import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ConstantsProvider } from './context/ConstantsContext';
import { StoreProvider } from './context/StoreContext';
import { SocketProvider } from './context/SocketContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import MainLayout from './components/layout/MainLayout';
import StoreSelector from './components/common/StoreSelector';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { getCurrentAppProfile, getProtectedModulesForProfile } from './config/moduleRegistry';

function App() {
  const profile = getCurrentAppProfile();
  const protectedModules = getProtectedModulesForProfile(profile);

  const renderProtectedModule = (module) => {
    const PageComponent = module.component;
    return (
      <ProtectedRoute
        requiredPermissions={module.requiredPermissions || []}
        requireAll={module.requireAll !== false}
      >
        <MainLayout title={module.title}>
          <PageComponent />
        </MainLayout>
      </ProtectedRoute>
    );
  };

  return (
    <AuthProvider>
      <ConstantsProvider>
        <StoreProvider>
          <SocketProvider>
            <Router>
              <StoreSelector />
              <Routes>
                {/* Public route for login */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />

                {/* Profile-aware protected routes */}
                {protectedModules.map((module) => (
                  <Route key={module.id} path={module.path} element={renderProtectedModule(module)}>
                    {Array.isArray(module.children) &&
                      module.children.map((child, index) => {
                        const ChildComponent = child.component;
                        if (child.index) {
                          return <Route key={`${module.id}-index-${index}`} index element={<ChildComponent />} />;
                        }
                        return (
                          <Route
                            key={`${module.id}-${child.path}-${index}`}
                            path={child.path}
                            element={<ChildComponent />}
                          />
                        );
                      })}
                  </Route>
                ))}
              </Routes>
            </Router>
          </SocketProvider>
        </StoreProvider>
      </ConstantsProvider>
    </AuthProvider>
  );
}

export default App;
